var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nav"},[_c('button',{staticClass:"nav-btn left",on:{"click":function($event){return _vm.emit('prev')}}}),_vm._v(" "),_c('button',{staticClass:"nav-btn right",on:{"click":function($event){return _vm.emit('next')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }